/**
 * Zentrale Übersetzungsdatei für das Benachrichtigungssystem
 * Central translation file for the notification system
 * 
 * Unterstützt: Arabisch (ar), Französisch (fr)
 * Supports: Arabic (ar), French (fr)
 */

export const notificationTranslations = {
  fr: {
    categories: {
      EXPIRED: 'Produits Expirés',
      EXPIRING: 'Expiration Proche',
      TRANSFER: 'Demandes de Transfert',
      REORDER: 'Réapprovisionnement Nécessaire',
      DELIVERY: 'Mises à Jour de Livraison',
      ECART: 'Écarts',
      GENERAL: 'Général'
    },
    messages: {
      productExpired: (productName, batchNumber, quantity) => 
        `${productName} (Lot: ${batchNumber}) a expiré (${quantity} unités)`,
      productExpiring: (productName, batchNumber, days, quantity) =>
        `${productName} (Lot: ${batchNumber}) expire dans ${days} jour(s) (${quantity} unités)`,
      reorderNeeded: (productName, stock) =>
        `${productName} nécessite un réapprovisionnement (Stock: ${stock})`,
      deliveryUpdate: (orderId, days) => {
        if (days === 0) {
          return `Commande ${orderId} livraison prévue aujourd'hui`;
        }
        return `Commande ${orderId} livraison prévue dans ${days} jour(s)`;
      },
      systemError: 'Le système de notifications a rencontré une erreur mais a récupéré.',
      markAsRead: 'Marquer comme lu',
      delete: 'Supprimer',
      clearAll: 'Tout effacer'
    },
    ui: {
      notifications: 'Notifications',
      noNotifications: 'Aucune notification',
      noNotificationsSubtext: 'Les notifications apparaîtront ici',
      filter: 'Filtrer',
      all: 'Tous',
      showRead: 'Afficher les lues',
      notificationCount: (count) => `${count} notification(s)`,
      now: 'Maintenant',
      hoursAgo: (hours) => `Il y a ${hours}h`,
      daysAgo: (days) => `Il y a ${days}j`,
      markAsReadTooltip: 'Marquer comme lu',
      deleteTooltip: 'Supprimer',
      clearAll: 'Tout effacer'
    },
    titles: {
      productExpired: 'Produit Expiré',
      productExpiring: 'Produit Expirant Bientôt',
      reorderNeeded: 'Réapprovisionnement Nécessaire',
      deliveryUpdate: 'Mise à Jour de Livraison',
      systemError: 'Erreur Système'
    }
  },
  ar: {
    categories: {
      EXPIRED: 'المنتجات المنتهية الصلاحية',
      EXPIRING: 'قريباً منتهي الصلاحية',
      TRANSFER: 'طلبات النقل',
      REORDER: 'إعادة الطلب مطلوبة',
      DELIVERY: 'تحديثات التسليم',
      ECART: 'الفروقات',
      GENERAL: 'عام'
    },
    messages: {
      productExpired: (productName, batchNumber, quantity) => 
        `${productName} (الدفعة: ${batchNumber}) انتهت صلاحيته (${quantity} وحدة)`,
      productExpiring: (productName, batchNumber, days, quantity) =>
        `${productName} (الدفعة: ${batchNumber}) تنتهي صلاحيته خلال ${days} يوم (${quantity} وحدة)`,
      reorderNeeded: (productName, stock) =>
        `${productName} يحتاج إلى إعادة طلب (المخزون: ${stock})`,
      deliveryUpdate: (orderId, days) => {
        if (days === 0) {
          return `الطلب ${orderId} متوقع تسليمه اليوم`;
        }
        return `الطلب ${orderId} متوقع تسليمه في ${days} يوم`;
      },
      systemError: 'واجه نظام الإشعارات خطأً لكنه تعافى.',
      markAsRead: 'تحديد كمقروءة',
      delete: 'حذف',
      clearAll: 'مسح الكل'
    },
    ui: {
      notifications: 'الإشعارات',
      noNotifications: 'لا توجد إشعارات',
      noNotificationsSubtext: 'ستظهر الإشعارات هنا',
      filter: 'تصفية',
      all: 'الكل',
      showRead: 'إظهار المقروءة',
      notificationCount: (count) => `${count} إشعار`,
      now: 'الآن',
      hoursAgo: (hours) => `منذ ${hours} ساعة`,
      daysAgo: (days) => `منذ ${days} يوم`,
      markAsReadTooltip: 'تحديد كمقروءة',
      deleteTooltip: 'حذف',
      clearAll: 'مسح الكل'
    },
    titles: {
      productExpired: 'منتج منتهي الصلاحية',
      productExpiring: 'منتج قريب منتهي الصلاحية',
      reorderNeeded: 'إعادة الطلب مطلوبة',
      deliveryUpdate: 'تحديث التسليم',
      systemError: 'خطأ في النظام'
    }
  },
  de: {
    categories: {
      EXPIRED: 'Abgelaufene Produkte',
      EXPIRING: 'Bald Ablaufend',
      TRANSFER: 'Transferanfragen',
      REORDER: 'Nachbestellung Erforderlich',
      DELIVERY: 'Lieferaktualisierungen',
      ECART: 'Abweichungen',
      GENERAL: 'Allgemein'
    },
    messages: {
      productExpired: (productName, batchNumber, quantity) => 
        `${productName} (Charge: ${batchNumber}) ist abgelaufen (${quantity} Einheiten)`,
      productExpiring: (productName, batchNumber, days, quantity) =>
        `${productName} (Charge: ${batchNumber}) läuft in ${days} Tag(en) ab (${quantity} Einheiten)`,
      reorderNeeded: (productName, stock) =>
        `${productName} benötigt eine Nachbestellung (Bestand: ${stock})`,
      deliveryUpdate: (orderId, days) => {
        if (days === 0) {
          return `Bestellung ${orderId} Lieferung voraussichtlich heute`;
        }
        return `Bestellung ${orderId} Lieferung voraussichtlich in ${days} Tag(en)`;
      },
      systemError: 'Das Benachrichtigungssystem ist auf einen Fehler gestoßen, hat sich aber erholt.',
      markAsRead: 'Als gelesen markieren',
      delete: 'Löschen',
      clearAll: 'Alle löschen'
    },
    ui: {
      notifications: 'Benachrichtigungen',
      noNotifications: 'Keine Benachrichtigungen',
      filter: 'Filtern',
      all: 'Alle',
      showRead: 'Gelesene anzeigen',
      notificationCount: (count) => `${count} Benachrichtigung(en)`,
      now: 'Jetzt',
      hoursAgo: (hours) => `vor ${hours} Stunde(n)`,
      daysAgo: (days) => `vor ${days} Tag(en)`,
      markAsReadTooltip: 'Als gelesen markieren',
      deleteTooltip: 'Löschen',
      clearAll: 'Alle löschen'
    },
    titles: {
      productExpired: 'Produkt Abgelaufen',
      productExpiring: 'Produkt Läuft Bald Ab',
      reorderNeeded: 'Nachbestellung Erforderlich',
      deliveryUpdate: 'Lieferaktualisierung',
      systemError: 'Systemfehler'
    }
  }
};

/**
 * Hilfsfunktion zum Abrufen von Übersetzungen
 * Helper function to get translations
 */
export const getNotificationTranslation = (language = 'fr', section, key, ...params) => {
  const lang = notificationTranslations[language] || notificationTranslations.fr;
  const sectionData = lang[section];
  
  if (!sectionData) {
    console.warn(`Notification translation section "${section}" not found for language "${language}"`);
    return key;
  }
  
  const translation = sectionData[key];
  
  if (typeof translation === 'function') {
    return translation(...params);
  }
  
  return translation || key;
};

/**
 * Abrufen der Kategorie-Bezeichnung
 * Get category label
 */
export const getCategoryLabel = (category, language = 'fr') => {
  return getNotificationTranslation(language, 'categories', category) || category;
};

/**
 * Abrufen der UI-Übersetzung
 * Get UI translation
 */
export const getUITranslation = (key, language = 'fr', ...params) => {
  return getNotificationTranslation(language, 'ui', key, ...params);
};

/**
 * Abrufen der Nachrichten-Übersetzung
 * Get message translation
 */
export const getMessageTranslation = (key, language = 'fr', ...params) => {
  return getNotificationTranslation(language, 'messages', key, ...params);
};

/**
 * Abrufen der Titel-Übersetzung
 * Get title translation
 */
export const getTitleTranslation = (key, language = 'fr') => {
  return getNotificationTranslation(language, 'titles', key);
};

